import BaseModel from '@core/model';

import ExchangeApi from '@packages/exchange/api';

export class Exchange extends BaseModel {
    static entity = 'exchange';
    static Api = ExchangeApi;

    static fields() {
        return {
            ...super.fields(),
            id: this.string(null).nullable(),
            name: this.string(null).nullable(),
            short_name: this.string(null).nullable(),
            lookup_url: this.string(null).nullable(),
            internal: this.boolean(false).nullable(),
            logo_id: this.string(null).nullable(),
            morningstar_code: this.string(null).nullable()
        };
    }
}

export default Exchange;
